const getCookies = () => {
	const cookies = {};

	if ( !document.cookie )
	{
		return cookies;
	}

	document.cookie.split( ';' ).forEach( ( it ) => {
		const item = it.split( '=' );

		cookies[item[0].trim()] = item[1].trim();
	} );

	return cookies;
}

const isFavourite = ( element ) => {
	const item = {
		isFavourite: false,
		toAdd: element.dataset.id,
		toRemove: null,
		name: element.dataset.commercial === 'yes' ? 'favourites_commercial' : 'favourites'
	};
	
	const cookies = getCookies();

	Object.keys( cookies ).forEach( ( it ) => {
		if ( /favourites_/.test( it ) && cookies[it] === item.toAdd )
		{
			item.isFavourite = true;
			item.toRemove = it;
		}
	} );
	
	return item;
};

export const recognizeFavourites = () => {
	Array.from( document.querySelectorAll(
		'ul.apartments a[data-id]:not(.checked), article.card, ul.feed li.feed-card a[data-id]:not(.checked)'
	) ).forEach( ( it ) => {
		const item = isFavourite( it );

		if ( item.isFavourite )
		{
			it.classList.add( 'favourite' );
			
			if ( it.querySelector( 'button.add-favourite' ).getAttribute( 'aria-label' ) )
			{
				it.querySelector( 'button.add-favourite' ).setAttribute( 'aria-label', 'Удалить из избранного' );
			}
			else
			{
				it.querySelector( 'button.add-favourite' ).innerHTML = 'В избранном';
			}
		}

		it.classList.add( 'checked' );
	} );
};

export const initFavourite = () => {
	const favouritesLink = document.querySelector( 'a.favourites[data-count]' );

	if ( !favouritesLink )
	{
		return;
	}

	const cookies = getCookies();
	let favouritesCount = 0;

	Object.keys( cookies ).forEach( ( it ) => {
		if ( /favourites_/.test( it ) )
		{
			favouritesCount++;
		}
	} );

	favouritesLink.dataset.count = favouritesCount;

	if ( !document.querySelector( 'button.add-favourite' ) )
	{
		return;
	}

	recognizeFavourites();

	document.addEventListener( 'click', ( evt ) => {
		const button = evt.target.closest('.add-favourite');

		if ( !button )
		{
			return;
		}

		evt.preventDefault();

		const item = isFavourite( button.closest( '[data-id]' ) );
		const time = Date.now();

		if ( item.isFavourite )
		{
			document.cookie = `${item.toRemove}=; expires=${new Date( 1970, 1, 1 )}; path=/`;
			const link = button.closest( '[data-id]' );
			if ( link )
			{
				link.classList.remove( 'favourite' );
				link.classList.add( 'animate' );
			}
			favouritesCount--;

			if ( button.getAttribute( 'aria-label' ) )
			{
				button.setAttribute( 'aria-label', 'Добавить в избранное' );
			}
			else
			{
				button.innerHTML = 'В избранное';
			}
		}
		else
		{
			document.cookie = `${item.name}_${time}_${item.toAdd}=${item.toAdd}; expires=${new Date( 2999, 5, 12 ).toUTCString()}; path=/`;
			button.closest( '[data-id]' ).classList.add( 'favourite', 'animate' );
			favouritesCount++;

			if ( button.getAttribute( 'aria-label' ) )
			{
				button.setAttribute( 'aria-label', 'Удалить из избранного' );
			}
			else
			{
				button.innerHTML = 'В избранном';
			}
		}

		favouritesLink.dataset.count = favouritesCount;
	} );
};
